import * as React from "react";
import {toast as sonnerToast} from "sonner";
import AppToast, {ToastProps} from "@/app/components/common/app-toast/AppToast";
import {APP_TOAST_DURATION_MS} from "@/lib/utils/contants/toast";

interface AppToastOptions {
    duration?: number;
}

type AppToastContent = Omit<ToastProps, 'duration'>;

// Single entry point for AppToast: the same duration feeds sonner's close timer and the
// toast's progress indicator, so the bar can never drift from the actual dismissal.
export function showAppToast(content: AppToastContent, options?: AppToastOptions) {
    const duration = options?.duration ?? APP_TOAST_DURATION_MS;

    return sonnerToast.custom(() => <AppToast {...content} duration={duration}/>, {duration});
}
